<script setup>
// Vista "Inicio" · estilo P4-D Triple capa magazine premium.
// Header brand · 3 fotos del portfolio (Sesión Brand / Editorial / Lifestyle) ·
// 4 KPIs (Leads / Sesiones / Ventas / Rating) en cards cristal negro M1.B.
import { computed } from 'vue';
import { useStore } from 'vuex';
import TopBar from 'dashboard/components-next/topbar/TopBar.vue';

const store = useStore();
const activeBranch = computed(() => store.getters['branches/getActiveBranch']);
const branchCode = computed(() => activeBranch.value?.code || '—');
</script>

<template>
  <div class="h-full w-full flex flex-col">
    <TopBar />

    <div class="hero-p4d">
      <!-- Top: brand strip + edition pill -->
      <div class="top-row">
        <div class="brand-strip">
          <div class="brand-mark">
            <span class="i-lucide-camera text-[26px]" />
          </div>
          <div class="brand-text">
            <div class="brand-name">VICTOR GUZMÁN</div>
            <div class="brand-tag">F O T O G R A F Í A</div>
          </div>
        </div>
        <div class="cover-issue-pill">
          ⭐ EDICIÓN 2025 · {{ branchCode }}
        </div>
      </div>

      <!-- 3 fotos lado a lado · la del medio destacada -->
      <div class="photo-row">
        <div class="photo-card photo-1">
          <div class="photo-card-content">
            <div class="photo-tag">Sesión Brand</div>
            <div class="photo-id">VG-001</div>
          </div>
        </div>
        <div class="photo-card photo-2">
          <div class="photo-card-content">
            <div class="photo-tag">Editorial Premium</div>
            <div class="photo-id">VG-002</div>
          </div>
        </div>
        <div class="photo-card photo-3">
          <div class="photo-card-content">
            <div class="photo-tag">Lifestyle</div>
            <div class="photo-id">VG-003</div>
          </div>
        </div>
      </div>

      <!-- 4 KPIs cards M1.B -->
      <div class="kpis-row">
        <div class="kpi-card">
          <div class="kpi-head">
            <div class="kpi-icon"><span class="i-lucide-target text-[14px]" /></div>
            <div class="kpi-delta">▲ 12%</div>
          </div>
          <div class="kpi-val">128</div>
          <div class="kpi-lbl">Leads activos</div>
        </div>
        <div class="kpi-card">
          <div class="kpi-head">
            <div class="kpi-icon"><span class="i-lucide-calendar-check text-[14px]" /></div>
            <div class="kpi-delta">▲ 8%</div>
          </div>
          <div class="kpi-val">47</div>
          <div class="kpi-lbl">Sesiones del mes</div>
        </div>
        <div class="kpi-card">
          <div class="kpi-head">
            <div class="kpi-icon"><span class="i-lucide-dollar-sign text-[14px]" /></div>
            <div class="kpi-delta">▲ 24%</div>
          </div>
          <div class="kpi-val">$92K</div>
          <div class="kpi-lbl">Ventas mes</div>
        </div>
        <div class="kpi-card">
          <div class="kpi-head">
            <div class="kpi-icon"><span class="i-lucide-star text-[14px]" /></div>
            <div class="kpi-delta">▲ 5%</div>
          </div>
          <div class="kpi-val">4.9</div>
          <div class="kpi-lbl">Rating clientes</div>
        </div>
      </div>
    </div>

    <!-- Contador de versión movido a App.vue: badge global fijo abajo-derecha
         "v{N}" visible en todas las pantallas (Victor 2026-05-26). -->
  </div>
</template>

<style scoped>
/* Hero P4-D · pixel-perfect del mockup */
.hero-p4d {
  flex: 1;
  background: radial-gradient(ellipse 80% 50% at 50% 0%, rgba(251,191,36,0.06), transparent 70%), #050505;
  overflow: hidden;
  padding: 32px;
  display: grid;
  grid-template-rows: auto 1fr auto;
  gap: 20px;
  font-family: -apple-system, system-ui, sans-serif;
  color: #fff;
}

/* Top row: brand + edition pill */
.top-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.brand-strip {
  display: flex;
  align-items: center;
  gap: 14px;
}
.brand-mark {
  width: 54px; height: 54px;
  border-radius: 14px;
  background: linear-gradient(135deg, #fbbf24, #d97706);
  display: flex; align-items: center; justify-content: center;
  color: #000;
  box-shadow: 0 0 28px rgba(251,191,36,0.4);
}
.brand-text { display: flex; flex-direction: column; }
.brand-name {
  font-size: 36px;
  font-weight: 900;
  letter-spacing: -1.5px;
  line-height: 0.95;
  background: linear-gradient(135deg, #fff 0%, #fbbf24 100%);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}
.brand-tag {
  font-size: 11px;
  letter-spacing: 8px;
  font-weight: 700;
  color: #fbbf24;
  margin-top: 4px;
}
.cover-issue-pill {
  display: flex; gap: 8px; align-items: center;
  padding: 8px 14px; border-radius: 999px;
  background: rgba(251,191,36,0.10);
  border: 1px solid rgba(251,191,36,0.35);
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 1.5px;
  color: #fbbf24;
  text-transform: uppercase;
}

/* Triple foto cards */
.photo-row {
  display: grid;
  grid-template-columns: 1fr 1.2fr 1fr;
  gap: 14px;
  height: 100%;
  min-height: 0;
}
.photo-card {
  position: relative;
  border-radius: 16px;
  background-size: cover;
  overflow: hidden;
  border: 1.5px solid rgba(251,191,36,0.30);
  box-shadow: 0 14px 40px rgba(0,0,0,0.6);
  cursor: pointer;
  transition: all 0.3s;
}
.photo-1 { background-image: url('/brand/home-foto-1.jpg'); background-position: center 25%; }
.photo-2 {
  background-image: url('/brand/home-foto-3.jpg');
  background-position: center 30%;
  box-shadow: 0 0 0 2px rgba(251,191,36,0.50), 0 0 30px rgba(251,191,36,0.25), 0 14px 40px rgba(0,0,0,0.6);
  transform: scale(1.02);
}
.photo-3 { background-image: url('/brand/home-foto-2.jpg'); background-position: center 35%; }
.photo-card::before {
  content: '';
  position: absolute; inset: 0;
  background: linear-gradient(180deg, transparent 0%, transparent 50%, rgba(0,0,0,0.85) 100%);
}
.photo-card:hover {
  transform: translateY(-4px);
  border-color: rgba(251,191,36,0.65);
  box-shadow: 0 20px 60px rgba(251,191,36,0.20);
}
.photo-2:hover { transform: translateY(-4px) scale(1.02); }

.photo-card-content {
  position: absolute; bottom: 16px; left: 16px; right: 16px;
  z-index: 2;
  display: flex; justify-content: space-between; align-items: flex-end;
}
.photo-tag {
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 1.2px;
  color: #fff;
  text-transform: uppercase;
}
.photo-id {
  font-family: 'Courier New', monospace;
  font-size: 9px;
  color: #fbbf24;
  letter-spacing: 1px;
  padding: 3px 8px;
  background: rgba(0,0,0,0.7);
  border-radius: 4px;
  border: 1px solid rgba(251,191,36,0.40);
}

/* KPIs */
.kpis-row {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
}
.kpi-card {
  padding: 14px 16px;
  background: rgba(10,10,10,0.85);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(251,191,36,0.30);
  border-radius: 12px;
  position: relative;
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.2s;
}
.kpi-card::before {
  content: '';
  position: absolute; inset: 0;
  pointer-events: none;
  border-radius: 12px;
  background:
    linear-gradient(120deg, transparent 12%, rgba(255,255,255,0.06) 22%, transparent 24%),
    radial-gradient(circle at 100% 0%, rgba(251,191,36,0.15), transparent 60%);
}
.kpi-card:hover {
  transform: translateY(-3px);
  border-color: rgba(251,191,36,0.55);
}
.kpi-card > * { position: relative; }
.kpi-head {
  display: flex; justify-content: space-between; align-items: center;
  margin-bottom: 6px;
}
.kpi-icon {
  width: 30px; height: 30px;
  border-radius: 8px;
  background: rgba(251,191,36,0.15);
  border: 1px solid rgba(251,191,36,0.35);
  display: flex; align-items: center; justify-content: center;
  color: #fbbf24;
}
.kpi-delta {
  font-size: 10px;
  font-weight: 800;
  padding: 3px 8px;
  border-radius: 5px;
  background: rgba(34,197,94,0.15);
  color: #4ade80;
  border: 1px solid rgba(34,197,94,0.30);
}
.kpi-val {
  font-size: 24px;
  font-weight: 900;
  color: #fff;
  line-height: 1;
}
.kpi-lbl {
  font-size: 10px;
  letter-spacing: 1.4px;
  text-transform: uppercase;
  color: rgba(255,255,255,0.55);
  font-weight: 700;
  margin-top: 4px;
}
</style>
